import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import CustomLoader from "../../component/CustomLoader/CustomLoader";
import api from "../../config/api";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import downloadFormsAction from "../../redux/downloadForms/action";
import PageHead from "../../component/pageHead/PageHead";
import ListWithCheckbox from "../../component/ListWithCheckbox/ListWithCheckbox";
import icon from "../../assets/icons/tick.png";
import CustomButton from "../../component/CustomButton/CustomButton";
import { isNetworkRequestFailedError } from "../../config/helpers";

class DownloadForms extends Component {
  state = {
    checkedArr: [],
    data: [],
    isLoading: false,
    loadingText: "fetching documents",
  };

  componentDidMount() {
    const { history, setHistory, data } = this.props;

    if (!data.length) {
      this.fetchDownloads();
    }

    setHistory(history);
  }

  fetchDownloads = async () => {
    const { setAlertMessage, setDownloadForms } = this.props;

    try {
      this.setState({ isLoading: true });

      const response = await api.fetchAllDownloadableForm();

      setDownloadForms(response.data.result);

      this.setState({ isLoading: false, data: response.data.result });
    } catch (e) {
      this.setState({ isLoading: false });
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchDownloads : null,
      });
    }
  };

  downloadForms = async () => {
    const { setAlertMessage, user } = this.props;
    const { checkedArr } = this.state;

    try {
      this.setState({ isLoading: true, loadingText: "Sending email" });

      if (!checkedArr.length)
        throw new Error("Please select atleast one document");

      await api.downloadForm({ documentIds: checkedArr.join() }, user.token);
      setAlertMessage({
        type: "success",
        message: "Email sent to your email address",
      });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.downloadForms : null,
      });
    }

    this.setState({ isLoading: false });
  };

  handleChecked = (id) => {
    const { checkedArr } = this.state;
    const index = checkedArr.indexOf(id);

    if (index === -1) checkedArr.push(id);
    else checkedArr.splice(index, 1);

    this.setState({ checkedArr });
  };

  render() {
    const { checkedArr, isLoading, loadingText } = this.state;
    const { data } = this.props;

    return (
      <Container style={{ position: "relative" }}>
        <PageHead
          title="DOWNLOAD AND EMAIL"
          containerStyles={{ width: "100%" }}
        />
        {data.map((item) => (
          <ListWithCheckbox
            key={Math.random().toString()}
            mainContainerClasses={"mx-4"}
            icon={icon}
            text={item.description}
            checked={checkedArr.includes(item.id)}
            id={item.id}
            onChecked={this.handleChecked}
          />
        ))}
        {!!data.length && (
          <Row className="my-2 justify-content-center">
            <Col className="p-0" md={3}>
              <CustomButton
                buttonClasses="btn-block"
                buttonText="Email Now"
                onClick={this.downloadForms}
              />
            </Col>
          </Row>
        )}
        {isLoading && <CustomLoader text={loadingText} />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  data: state.downloadForms.data,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setDownloadForms: downloadFormsAction.setDownloadForms,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadForms);
